import PropTypes from "prop-types";
import React, { Component } from "react";
import MuiToggle from "material-ui/Toggle";

/** @augments {Component<any, any>} */
class Toggle extends Component {
    static contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };

    static propTypes = {
        style: PropTypes.object,
    };

    render() {
        const { style, disabled = false, ...other } = this.props;
        return <MuiToggle disabled={disabled} style={Object.assign({ paddingLeft: "4px" }, style)} {...other} />;
    }
}

export default Toggle;
